/**
 * PII 脱敏工具（Issue #198）。
 *
 * 后端响应应在 API 层完成脱敏；此处是 UI 层的"双重保险"，避免极端情况下
 * 原文意外泄漏。生产环境永远不要把原始手机号/身份证写入 logs 或 console。
 */

const PHONE_REGEX = /^1\d{10}$/;
const ID_NUMBER_REGEX = /^[1-9]\d{16}[0-9Xx]$/;

export function maskPhone(phone: string | null | undefined): string {
  if (!phone) return '';
  if (!PHONE_REGEX.test(phone)) return phone;
  return `${phone.slice(0, 3)}****${phone.slice(7)}`;
}

export function maskIdNumber(id: string | null | undefined): string {
  if (!id) return '';
  if (!ID_NUMBER_REGEX.test(id)) return id;
  return `${id.slice(0, 4)}**********${id.slice(-4)}`;
}

export function maskName(name: string | null | undefined): string {
  if (!name) return '';
  if (name.length <= 1) return name;
  if (name.length === 2) return `${name[0]}*`;
  return `${name[0]}${'*'.repeat(name.length - 2)}${name[name.length - 1]}`;
}
